define("Modules/Map", [`Module`, `module`], (Super, Self) => {
	return Super.inherit({
		namespace: Self.id,
		defaults: {
			scale: 2,
			zoom: 16,
		},
		constructor({ place }) {
			if (!this.isObject(place)) {
				throw new Error(`Modules/Map(): setup.place is required.`);
			}

			const { DOM, System } = this;
			const system = System.get();
			const { isiOS } = system;
			const viewport = DOM.getViewportDimensions();
			const isMobile = viewport.width < 800;
			const { address, name } = place;
			const { streetAddress, postalCode, state, city } = address;
			const summary = `${name}, ${streetAddress}, ${city}, ${state} ${postalCode}`;
			const query = encodeURIComponent(summary);
			const mapUrl = isMobile ? place.mobileMapUrl : place.mapImageUrl;
			let linkUrl;

			if (isiOS) {
				// webview for the iOS Tixr app
				linkUrl = `https://maps.apple.com/?q=${query}`;
			} else {
				// anything else
				linkUrl = `https://www.google.com/maps/preview?q=${query}`;
			}

			this.assign(this.data, { linkUrl, mapUrl, place });
			this.render();
		},
	});
});

define("Modules/Map.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Modules/Map/main"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a class=\"map\" aria-label=\"map\" href=\""
    + alias2(alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"linkUrl")), depth0))
    + "\" style='background-image: url(\""
    + alias2(alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"mapUrl")), depth0))
    + "\")'> <div class=\"spacer\"></div> </a> <p> "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + " "
    + ((stack1 = lookupProperty(helpers,"with").call(alias3,(depth0 != null ? lookupProperty(depth0,"address") : depth0),{"name":"with","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":169},"end":{"line":1,"column":326}}})) != null ? stack1 : "")
    + " </p> <a class=\"button small\" theme=\""
    + ((stack1 = lookupProperty(helpers,"compare").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"theme")),"DARK",{"name":"compare","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":1,"column":363},"end":{"line":1,"column":424}}})) != null ? stack1 : "")
    + "-OUTLINE\" href=\""
    + alias2(alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"linkUrl")), depth0))
    + "\"> <p>Open in maps</p> </a> ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <br />"
    + container.escapeExpression(lookupProperty(helpers,"join").call(alias1,(depth0 != null ? lookupProperty(depth0,"streetAddress") : depth0),(depth0 != null ? lookupProperty(depth0,"extendedAddress") : depth0),(depth0 != null ? lookupProperty(depth0,"city") : depth0),(depth0 != null ? lookupProperty(depth0,"state") : depth0),", ",{"name":"join","hash":{},"data":data,"loc":{"start":{"line":1,"column":193},"end":{"line":1,"column":247}}}))
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"postalCode") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":247},"end":{"line":1,"column":316}}})) != null ? stack1 : "")
    + " ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"state") : depth0),{"name":"unless","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":265},"end":{"line":1,"column":294}}})) != null ? stack1 : "")
    + " "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"postalCode") : depth0), depth0));
},"4":function(container,depth0,helpers,partials,data) {
    return ",";
},"6":function(container,depth0,helpers,partials,data) {
    return "WHITE";
},"8":function(container,depth0,helpers,partials,data) {
    return "BLACK";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"place") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":494}}})) != null ? stack1 : "");
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=Map.js.map